import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, Spinner, Text, Link } from "samba-ui";
import styled from "styled-components";
import { loadPeriscopeUrl } from "../api";

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const ShowPeriscopeUrl = ({ dashboard, dashboardFilters }) => {
  const [loading, setLoading] = useState(true);
  const [embedUrl, setEmbedUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const req = async () => {
      const body = { dashboard, dashboardFilters };
      try {
        const res = await loadPeriscopeUrl(body);

        if (res.status === 200) {
          const { data } = await res.json();
          setEmbedUrl(data);
        } else {
          setError("Error occured while generating the url");
        }
      } catch (e) {
        setError("Error occured while generating the url");
      } finally {
        setLoading(false);
      }
    };
    req();
  }, [dashboard, dashboardFilters]);
  return (
    <Box>
      {error ? (
        <Text> Error occured</Text>
      ) : loading ? (
        <Spinner variant="xsmall" color="primary" />
      ) : (
        <StyledLink target="blannk" href={embedUrl}>
          Show Dashboard
        </StyledLink>
      )}
    </Box>
  );
};

ShowPeriscopeUrl.propTypes = {
  dashboard: PropTypes.object,
  dashboardFilters: PropTypes.array
};

export default ShowPeriscopeUrl;
